import TagManager from "react-gtm-module";
import history from "./history";

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GTM_ID,
};

const GTM_initGA = () => {
  TagManager.initialize(tagManagerArgs);
  history.listen((location) => {
    if (location.pathname.includes("/user")) {
      let rootURL = location.pathname.split("/")[1];
      let userPage = location.pathname.split("/")[3];
      let pageHit = `/${rootURL}/${userPage}`;
      GTM_PageView({ page: pageHit });
    } else {
      GTM_PageView(false);
    }
  });
};

const GTM_PageView = (params) => {
  if (params && params.page) {
  } else {
  }
};

const GTM_Event = async (category, action, label, value, data) => {
  const tagManagerArgs = {
    dataLayer: {
      event: "appEvent",
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
      eventValue: value,
    },
  };

  tagManagerArgs.dataLayer.app_env = localStorage.app_env;
  let user = data && data.user_id ? data : data && data.user ? data.user : null;
  if (user) {
    tagManagerArgs.dataLayer.user_id = localStorage.user_id;
    tagManagerArgs.dataLayer.role = localStorage.role;
    tagManagerArgs.dataLayer.account_name = localStorage.account_name;
    tagManagerArgs.dataLayer.account_id = localStorage.account_id;
    tagManagerArgs.dataLayer.first_name = user.first_name;
    tagManagerArgs.dataLayer.last_name = user.last_name;
    tagManagerArgs.dataLayer.accountType =
    localStorage.is_callcenter_enabled && localStorage.is_callcenter_enabled.toLowerCase() === "true"
        ? "CC"
        : "Non-CC";
    tagManagerArgs.dataLayer.billingType = localStorage.billing_type
      ? localStorage.billing_type
      : "";
  }
  TagManager.dataLayer(tagManagerArgs);
};

const GTM_Tracker = {
  init: GTM_initGA,
  pageview: GTM_PageView,
  event: GTM_Event,
  event_v2: GTM_Event,
};

export const Tracker = GTM_Tracker;
